import { ChangeDetectionStrategy, Component, Input, inject, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CopilotFacadeService } from '@brighthub/copilot';
import { ConversationService } from '../conversation.service';
import { ConversationInfoComponent } from '../conversation-info/conversation-info.component';
import { Tooltip } from 'primeng/tooltip';
import { ScrollRegionComponent } from '@brightside/angular-bds';
import { UiSession } from '@brighthub/uisession';

@Component({
  selector: 'lib-conversation-list',
  imports: [CommonModule, ConversationInfoComponent, Tooltip, ScrollRegionComponent],
  templateUrl: './conversation-list.component.html',
  styleUrl: './conversation-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationListComponent {
  @Input() collapsed = false;
  private _facadeService = inject(CopilotFacadeService);
  private _router = inject(Router);
  readonly conversationService = inject(ConversationService);

  routeTo() {
    this._facadeService.clearContext();
    this._router.navigate(['/brightnav/myclients']);
  }

  selectConversation(conversation: UiSession) {
    this.conversationService.setActiveConversation(conversation);
    this._router.navigate([`/brightnav/conversation/${conversation.conversationId}`]);
  }

  trackByConversationId(_index: number, conversation: UiSession): string {
    return conversation.conversationId ?? '';
  }
}
